import { combineReducers } from "redux";
import active from "./active";

export default combineReducers({
    active 
});